import { compulsoryColumns, excludedColumns } from "@Components/FileColumnsTreeView/constants";
import axiosWrapper from "@Services/axiosWrapper";
import { getBackendUrl } from "@Utils";

export const getFilteredColumns = (columns) =>
  columns.filter((col) => {
    let column = col;
    if (typeof column != "string") {
      column = col.field;
    }
    let includeColumn = true;

    excludedColumns.forEach((excludedColumn) => {
      if (excludedColumn.field == column && includeColumn) {
        includeColumn = false;
      }
    });

    compulsoryColumns.forEach((compulsoryColumn) => {
      if (compulsoryColumn.field == column && includeColumn) {
        includeColumn = false;
      }
    });

    return includeColumn;
  });

export const getFilePropertyNames = async (fileVersionId) => {
  const propertyNames = await axiosWrapper.post(`${getBackendUrl()}/queries/getDistinctFilePropertyNames`, {
    fileVersionId: Array.isArray(fileVersionId) ? fileVersionId : [fileVersionId],
  });

  let columns = [];
  if (propertyNames.data.status) {
    columns = getFilteredColumns(propertyNames.data.data);
  }
  return [columns, propertyNames.data];
};

export const convertToDotNotation = (obj, parentKey = "", result = {}) => {
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      const checkForObjectInCustomFields = typeof obj[key] === "object" && parentKey != "customProperties";

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key]) &&
        checkForObjectInCustomFields
      ) {
        convertToDotNotation(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};

export const getModifiedNodesList = (modelProperties) => {
  return Object.values(modelProperties)
    .flatMap(Object.values)
    .map((data) => ({
      id: data._id,
      ...convertToDotNotation(data),
    }));
};

export const extractPropertyPartialName = (field) => {
  const rootProperty = field.split(".");
  const value = rootProperty.slice(1).join(".").split("/");
  if (value.length > 1) {
    return value.slice(1).join("/");
  }
  return value[0];
};
